import { render, staticRenderFns } from "./PackagingDashboard.vue?vue&type=template&id=74b2b390"
import script from "./PackagingDashboard.vue?vue&type=script&lang=js"
export * from "./PackagingDashboard.vue?vue&type=script&lang=js"
import style0 from "./PackagingDashboard.vue?vue&type=style&index=0&id=74b2b390&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports